import { render, staticRenderFns } from "./infoAccordeonBlock.vue?vue&type=template&id=038a0267&scoped=true&"
import script from "./infoAccordeonBlock.vue?vue&type=script&lang=js&"
export * from "./infoAccordeonBlock.vue?vue&type=script&lang=js&"
import style0 from "./infoAccordeonBlock.vue?vue&type=style&index=0&id=038a0267&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a0267",
  null
  
)

export default component.exports